<script setup lang="ts">
import { renderSVG } from 'uqr';

const props = defineProps<{
  alt: string;
  utmSource: string;
}>();

const { getAppUrl } = useRuntimeConfig().public.mobileApp;

const qrTargetUrl = new URL(getAppUrl);
qrTargetUrl.searchParams.set('utm_source', props.utmSource);
qrTargetUrl.searchParams.set('utm_medium', 'qr');

const qrDataUrl = `data:image/svg+xml;base64,${btoa(renderSVG(qrTargetUrl.toString(), { ecc: 'M', border: 2 }))}`;
</script>

<template>
  <img
    :src="qrDataUrl"
    :alt="alt"
    class="w-[132px] h-[132px]"
  >
</template>
